var GoldenEggModal = require('components/games/GoldenEggModal');

class GoldenEgg extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			mainEggVisible: true
		};
	}

	onClick(e) {
		$wr.nope(e)
		this.refs.modal.show();
		Mycroft.newEvent({ category: "GoldenEgg", action: "open-egg" });
	}

	hideEgg() {
		this.setState({ mainEggVisible: false })
	}

	render() {
		if (this.state.mainEggVisible) {
			var eggImage= (
				<a href="#">
					<img src={ require('goldenegg/egg-0.png')} className="goldenEggOutofModal" onClick={ this.onClick } />
				</a>
			)
		}

		return(

            <div className="eggs">
				{ eggImage }
				<GoldenEggModal ref="modal" onComplete={ this.hideEgg }/>
			</div>

		)
 	}
};

module.exports = GoldenEgg;



// WEBPACK FOOTER //
// ./modules/components/games/GoldenEgg.js